"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allOrderLinesCancelled = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
/**
 * Checks if all order lines in an order have been cancelled (in any cancellation state)
 * @param order The order to check
 * @returns boolean indicating if all order lines are in a cancelled state
 */
const allOrderLinesCancelled = (order) => {
    if (!order)
        return false;
    if (!order.order_lines)
        return false;
    if (!order.default_variant_id)
        return false;
    if (!order.variants)
        return false;
    const order_lines = order?.variants.find((variant) => variant.id === order.default_variant_id)?.order_lines;
    if (!order_lines)
        return false;
    if (order_lines.length === 0)
        return false;
    const line_statuses = order_lines.map((line) => {
        if (!line.versions)
            return "UNKNOWN";
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
        if (!latest_version)
            return "UNKNOWN";
        return latest_version.status;
    });
    // Define all possible cancellation statuses
    const cancellationStatuses = [
        "CANCELLED",
        "CANCELLED_REJECTED_BY_CLIENT",
        "CANCELLED_UNAVAILABLE",
        // Add any other cancellation states here as needed
    ];
    const cancelled_statuses = line_statuses.filter((status) => cancellationStatuses.includes(status));
    return (line_statuses.length > 0 &&
        line_statuses.length === cancelled_statuses.length);
};
exports.allOrderLinesCancelled = allOrderLinesCancelled;
